'use strict';

var DeleteUserService = function DeleteUserService(restangular, $q) {
  var userService = restangular.one('user');
  function removeUsers(users) {
    var promises = [];
    users.forEach(function (user) {
      promises.push(userService.customDELETE(user.userId));
    });
    return $q.all(promises);
  }
  return {
    removeUsers: removeUsers
  };
};
DeleteUserService.$inject = ['Restangular', '$q', 'UserSecureService'];
module.exports = DeleteUserService;